import type { CEDE_CEXS } from "@cede/types";
import { CampaignSummaryWithStats } from "@/components/features/campaigns/types";

/**
 * Counts the number of campaigns available on each exchange
 */
export function getCampaignCountsByExchange(
  supportedExchanges: CEDE_CEXS[],
  campaigns: CampaignSummaryWithStats[],
): Record<CEDE_CEXS, number> {
  const countsByExchange = Object.fromEntries(supportedExchanges.map((exchangeId) => [exchangeId, 0])) as Record<
    CEDE_CEXS,
    number
  >;

  for (const campaign of campaigns) {
    const exchangeIds: string[] = campaign?.exchangeIds ?? [];
    for (const exchangeId of exchangeIds) {
      if (exchangeId in countsByExchange) {
        countsByExchange[exchangeId as CEDE_CEXS] = (countsByExchange[exchangeId as CEDE_CEXS] ?? 0) + 1;
      }
    }
  }

  return countsByExchange;
}
